module.exports = __webpack_public_path__ + "img/section4_2.f8a23411.png";